import React, { useEffect, useState } from 'react';

import { Animation } from 'components/lottie-animations/logo';

type Props = {
  width?: string; // These props will still be used for desktop logos.
  height?: string;
};

export const Logo: React.FC<Props> = props => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 430); // Mobile size condition
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // For Mobile, return fixed-size SVG
  if (isMobile) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="41"
        viewBox="0 0 35 41"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 13.9531L3.5335 18.2174C3.5335 18.2174 5.42284 15.441 7.75206 17.3039C9.53976 18.7337 8.99536 21.3189 8.54887 23.4392C8.41362 24.0815 8.28736 24.6811 8.23762 25.193C7.966 27.9958 8.65587 30.2625 9.78322 32.0629C11.2183 34.3537 14.5498 36.2598 18.1266 36.9353C18.4006 36.9858 18.6626 37.0242 18.9222 37.0579L19.2948 41H21.9894L22.3524 37.1468C28.5372 36.6492 37.2868 30.599 33.3928 20.4096C31.602 15.7223 27.8065 8.72258 27.8065 8.72258L27.8497 8.71056C29.3521 8.32837 29.6429 6.37893 27.8882 5.33331L29.143 4.1723L27.3089 3.41993L27.994 0.912827L24.0542 2.47286L24.0663 2.46324C24.0663 2.46324 23.0687 0.381601 21.5495 0.364774C20.2707 0.350352 19.6674 1.27579 19.6674 1.27579C19.6674 1.27579 19.3261 0.323911 18.4511 0.0643068C17.5762 -0.195297 16.1483 0.314296 15.968 1.90317C15.7661 3.68434 17.2036 4.60017 17.6771 4.7516C17.7202 4.76542 17.7646 4.78031 17.8105 4.79571C18.3636 4.98134 19.1407 5.24216 20.6433 4.60738C20.6423 5.27758 20.6405 6.30986 20.6386 7.42587V7.42735C20.6358 9.03277 20.6327 10.8111 20.6313 11.934C20.6306 12.289 20.6346 12.6757 20.6389 13.084C20.6642 15.5158 20.6976 18.717 19.79 20.5754C18.7299 22.746 17.5233 23.6498 15.9248 23.4623C14.1388 23.2532 13.5283 21.5802 14.1484 18.477C14.7686 15.3737 15.2926 12.2849 12.6918 9.98455C10.0909 7.68417 5.40361 7.42937 0 13.9531ZM24.398 3.98721C24.7994 3.78049 25.3138 3.9824 25.5445 4.4319C25.7753 4.88381 25.6359 5.41744 25.2345 5.62176C24.833 5.82607 24.3186 5.62897 24.0879 5.17706C23.8571 4.72516 23.9965 4.19153 24.398 3.98721Z"
          fill="#FF7D00"
        />
        <path
          d="M25.6599 40.6873L25.3114 39.8916H25.1215V40.9998H25.2657V40.1104L25.5902 40.8507H25.7296L26.0517 40.1104V40.9998H26.196V39.8916H26.0037L25.6599 40.6873Z"
          fill="#FF7D00"
        />
        <path
          d="M24.4917 40.0311H24.1672V39.8916H24.9652V40.0311H24.6407V40.9998H24.4917V40.0311Z"
          fill="#FF7D00"
        />
      </svg>
    );
  }

  // For Desktop, use the animation logo
  return (
    <React.Suspense fallback={null}>
      <Animation {...props} />
    </React.Suspense>
  );
};
